<template>
  <div id="introCss">

    <div class="goodsInfo">
              <div v-for="(item,index) in goodsLst"  @click="goDtl(item.GOODS_ID)" :style="SBXH=='PC'?'width:25%;display: flex;justify-content: center;':'width:33.3%;display: flex;justify-content: center;'">
                   <span class="gdetail" style="border-radius:0.5rem;width:90%"  >
                  <el-image :src="imgBSUrl+item.IMG" style="border-top-left-radius:0.5rem;border-top-right-radius:0.5rem;width:100%;height:auto;"></el-image>
                  <label-wrap style="padding:0.5rem;height:50px;">{{item.REMARK2.replace('(平台直营)','').replace('(平台直营）','').replace('（平台直营）','')}}</label-wrap>
                  <label style="color:red;font-size: 2rem;"><label style="font-size: 1rem;">￥</label>{{item.PRICE}}</label>
                </span>
              </div>
    </div>
  </div>
</template>

<script>
import { getSBXH} from "../../api/common.js";

export default {
  name: "goods-list",
  props:['goodsLst'],
  data(){
    return{
      imgBSUrl: '',
      SBXH:''

    }
  },
  created() {
    this.imgBSUrl = this.$imgBaseUrl;
    this.SBXH=getSBXH();
  },
  methods: {
    goDtl(goodsid){

      const {href} = this.$router.resolve({
        name: 'Detail', query: {goodsid: goodsid}
      })
      window.open(href)
    }
  }

}
</script>

<style scoped>
#introCss{
  display: flex;
  flex-direction: column;
  /*margin: 15px;*/
  /*border: 1px solid #CCCCCC;*/
  /*padding: 15px;*/
}
#introCss .topTitle{
  display: flex;
  justify-content: space-between;
}
#introCss .goodsInfo{
  display: flex;
  /*justify-content: space-between;*/
  /*margin-top:15px;*/
  width: 100%;
  flex-wrap: wrap;
  /*justify-content: space-between;*/
}
#introCss .goodsInfo .gdetail{
  display: flex;
  flex-direction: column;
  box-shadow:1px 4px 6px #CCCCCC;
  align-items: center;
  font-size: 1.2rem;


  margin-top:15px;
  margin-right: 2%;
}
#introCss .goodsInfo .gdetail:hover{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/sidebar/goods-list.vue